import { combineReducers } from "@reduxjs/toolkit";
import loaderReducer from "./feature/loader/loaderSlice";
import userReducer from "./feature/userSlice";
import tempReducer from "./feature/tempSlice";
import campaignReducer from "./lead/campaignReducer";

const appReducers = combineReducers({
  // apiStatus: apiStatusReducer,
  user: userReducer,
  loader: loaderReducer,
  temp: tempReducer,
  campaign: campaignReducer,
  // tempData: tempDataReducer,
});

// for reseting root reducer on logout
const rootReducer = (state: any, action: any) => {
  if (action.type === "user/reset_all_data") {
    localStorage.removeItem("persist:root");
    window.location.href = "/";
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducer;
